import React, { Component } from 'react'
import styled from 'styled-components'
import LinkHandler from './LinkHandler'
import Link from './Link'

const StyledMoreLink = styled(Link)`
  color: ${props => props.theme.moreLink.color};
  font-size: 14px;
  line-height: 22px;
  text-decoration: underline;
  z-index: 1;
  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    margin-left: 0px;
  }
`

/**
 * Component for Widget more link rendering
 */
export default class MoreLink extends Component {
  /**
   *
   * @returns {null|XML}
   */
  render () {
    if (typeof this.props.widget.meta.more === 'undefined') {
      return null
    }

    const {
      widget: {
        meta: {
          more,
          admon = null
        },
        utmContent,
        utmMedium,
        utmSource
      },
      activeSection
    } = this.props
    const {
      text,
      location
    } = (Array.isArray(more)) ? more[activeSection] : more
    const utmParams = {
      utmContent,
      utmMedium,
      utmSource,
      utmTerm: 'morelink'
    }
    const link = new LinkHandler(location).addUTMParams(utmParams).applySASRedirect(admon).link

    return (
      <StyledMoreLink href={link} title={text}>
        { text }
      </StyledMoreLink>
    )
  }
}
